import src from "IMAGE";
export default { src, width: 478, height: 105, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAIAAADq9gq6AAAAPUlEQVR42gEyAM3/ALvK4rbG4LTE37LD3oSmxpix0Ziu07HC3QCTqtCVrNGKo82GoMt2lMSCncl0ksOCnclkuiFSmsAZ1AAAAABJRU5ErkJggg=="};
